var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0H2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2zM1 3.857A.937.937 0 012 3h12a.937.937 0 011 .857v10.286A.937.937 0 0114 15H2a.937.937 0 01-1-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.542 6.812a1.067 1.067 0 000-2.125 1.067 1.067 0 000 2.125zm2.915 0a1.067 1.067 0 10-.972-1.062 1.02 1.02 0 00.972 1.062zm2.915 0A1.067 1.067 0 1011.4 5.75a1.02 1.02 0 00.972 1.062zM3.631 10a1.067 1.067 0 000-2.125 1.067 1.067 0 000 2.125zm2.915 0a1.067 1.067 0 000-2.125 1.067 1.067 0 000 2.125zm2.915 0a1.067 1.067 0 10-.972-1.062A1.02 1.02 0 009.457 10zm2.915 0a1.067 1.067 0 10-.972-1.062A1.02 1.02 0 0012.372 10zm-8.745 3.187a1.067 1.067 0 000-2.125 1.067 1.067 0 000 2.125zm2.915 0a1.067 1.067 0 000-2.125 1.067 1.067 0 000 2.125zm2.915 0a1.067 1.067 0 10-.972-1.062 1.02 1.02 0 00.968 1.062z"
  }))));
}

export default SvgIconCalendar;